/**
 * A refusal that no screen showed (B-31).
 *
 * The server turns an action down with a 4xx and a sentence written for the
 * user ("You have already reported this item in the last 24 hours"). useAxios
 * raises 401, 403, 5xx and network failures itself, but a refusal used to be
 * left entirely to the screen that asked, and a screen that showed nothing
 * left a button that silently did nothing (following someone, saving the
 * onboarding privacy choice).
 *
 * Most screens DO show refusals, in place or in their own toast, so useAxios
 * cannot simply toast them all. Instead it holds a refusal's toast back for one
 * task (setTimeout 0: every catch in the request's promise chain runs before
 * it) and shows it only if nobody claimed it in the meantime:
 *
 *   - any toast raised meanwhile claims it. SnackBarProvider calls
 *     claimRefusals() on every raise, so a screen that toasts its own message
 *     is not toasted twice;
 *   - a screen that shows the refusal in place (an inline error, a page state)
 *     calls claimRefusals() as the FIRST statement of its catch, before any
 *     await;
 *   - a write nobody tapped passes `quietRefusal: true`: it is never held, so
 *     it cannot swallow a refusal the user is waiting for, and its outages
 *     (5xx, no network) are still raised as before. `quiet: true`, for
 *     background reloads (B-61), silences both.
 *
 * Kept free of imports so the many screens that claim do not pull axios or a
 * provider into their test bundles.
 */
const pending = new Set();

export const holdRefusal = (show) => {
  const timer = setTimeout(() => {
    pending.delete(timer);
    show();
  });
  pending.add(timer);
};

export const claimRefusals = () => {
  pending.forEach(clearTimeout);
  pending.clear();
};
